import { NgModule } from '@angular/core';

import { AudioChannelCoreApiService } from '../api';

import { SysApiAudioChannelCoreApiService } from './sys-api-audio-channel-core-api.service';

@NgModule({
	providers: [
		SysApiAudioChannelCoreApiService,
		{
			provide: AudioChannelCoreApiService,
			useClass: SysApiAudioChannelCoreApiService
		}
	]
})
export class SysApiAudioChannelCoreDataAccessModule {}
